import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";

export default class TeamsSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Teams",
            description              : "This module enables direct integration with Microsoft Teams, allowing for seamless communication and collaboration within your workspace. This connection facilitates easy sharing of updates, tasks, and files, ensuring your team stays synchronized and productive without leaving the Teams environment",
            svgIcon                  : "isvg-ms-teams-integration",
            settingsUrl              : "settings/integrations/teams",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations",
        });

        this._isEnabled             = false
        // this.canDisable             = false
        this.isComingSoon           = true

        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
